<template>
  <div class="flex justify-center">
    <div class="w-screen lg:w-2/3">
      <!-- <div class="p-2 bg-red-800 sm:bg-red-600 md:bg-red-400 lg:bg-red-200">
      width bar
    </div> -->
      <div class="m-4">
        <!-- 알림 메세지 -->
        <div v-if="page.need_update" class="m-4 w-full border-2">
          홈페이지 내용 업데이트 필요합니다. {{ page.need_update_msg }}
          <button @click="onReload">새로고침</button>
        </div>

        <!-- 상단 메뉴들 -->
        <div class="flex">
          <div class="m-4">
            <div v-if="is_dark">
              <button @click="onToggleDark">☀️</button>
            </div>
            <div v-else>
              <button @click="onToggleDark">🌙</button>
            </div>
          </div>

          <!-- 메뉴둘 -->
          <div class="m-4">
            <button @click="router.push('/')">홈</button>
          </div>
        </div>

        <!-- 제목 -->
        <h1>{{ title }}</h1>

        <div class="flex justify-center">
          <div class="tw_main">
            <main>
              <router-view />
            </main>
          </div>
        </div>

        <!-- footer 1 -->
        <div class="mt-4">
          카카오 오픈 채팅방) -
          <a href="https://open.kakao.com/o/gqxgklph">링크</a>
        </div>

        <!-- 구글애드센스 이미지 큰 광고 
        <div>
          <Adsense
            adStyle="display:block"
            format="fluid"
            layoutKey="-71+ed+2h-1n-4u"
            clientId="ca-pub-4928043623873125"
            slotId="1116855090"
          >
          </Adsense>
        </div>
        -->

        <!-- version -->
        <div class="m-2 flex justify-end items-center">
          <div class="font-bold">v{{ VERSION }}</div>
          <div class="ml-2" v-if="is_dev">DEV</div>
          <div class="ml-2 text-xs">({{ moment(BUILD_DATE).fromNow() }})</div>
          <div class="ml-2 h-6 items-end">
            <iframe
              src="https://myhits.vercel.app/api/hit/https%3A%2F%2Fbitaxe.sidnft.com?color=blue&label=hits&size=small&base_count=1"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// App.vue
// import { motion } from "motion-v";
import moment from "moment";
import * as Vue from "vue";
import { useRoute, useRouter } from "vue-router";
import { useDark, useToggle } from "@vueuse/core";
// import { Icon } from "@iconify/vue";
import { VERSION, BUILD_DATE } from "@/ver";
// import im2 from "@/components/Img2.vue";
import * as Helper from "@/helper";
import * as Types from "@/types";
// import { Adsense } from "vue3-google-adsense";
// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCrorCbEm5BxHLWA9pECPksltxKoqULP50",
//   authDomain: "homminer-3ccbc.firebaseapp.com",
//   projectId: "homminer-3ccbc",
//   storageBucket: "homminer-3ccbc.firebasestorage.app",
//   messagingSenderId: "744597188257",
//   appId: "1:744597188257:web:4d034ca5daa3e83dd70ae0",
//   measurementId: "G-88B3YS45QB",
// };

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

const route = useRoute();
const router = useRouter();

const title = "비트코인 채굴기 성능 비교";
const is_dev = Helper.is_dev();
const URL_HEAD = Types.get_url_head();

const is_dark = useDark();
const toggle_dark = useToggle(is_dark);

const page = Vue.ref<any>({
  //
});

// 로그 끄기기
if (is_dev == false) {
  console.log = () => {};
}

Vue.onMounted(async () => {
  document.title = title;

  try {
    const url = URL_HEAD + "/bitaxe/first";
    const res = await Helper.web_get(url);
    console.log("res", res.data);
    if (res.data.code != 200) {
      throw new Error("first fail");
    }

    const ver = Number(res.data.ver);

    console.log(`ver, ${VERSION} -> ${ver}`);
    if (VERSION < ver) {
      // 업데이트 해야한다.
      page.value.need_update = true;
      page.value.need_update_msg = `v${VERSION} 👉️ v${ver}`;
    }
  } catch (err) {
    const e = err as Error;
    console.log("req err first", e.message);
  }
});

function onToggleDark() {
  toggle_dark();
}

// 새로고침
function onReload() {
  window.location.reload();
}
</script>

<style scope></style>
